// extracted by mini-css-extract-plugin
export default {"box":"ingredient-preview_box__2Zjwr","imgCardSmallFonNumber":"ingredient-preview_imgCardSmallFonNumber__BiBkW"};